import { Edit, useTranslate } from "react-admin"
import FormInput from "./FormInput"


const CustomerEdit = () => {

  const translate = useTranslate()

  return (
    <Edit redirect="list" title={translate("resources.customers.name", {smart_count: 1})}>
      <FormInput />
    </Edit>
  )
}

export default CustomerEdit